import type {
  TooltipOwnerState as BaseTooltipOwnerState,
  TooltipProps as BaseTooltipProps,
} from '@mui/joy/Tooltip';
import type { IconComponentType } from '../../types';

export enum TooltipModes {
  LIGHT = 'light',
  DARK = 'dark',
}

export type TooltipProps = {
  title?: string | React.ReactNode;
  titleNode?: React.ReactNode;
  description?: React.ReactNode;
  startDecoratorComponent?: IconComponentType;
  startDecoratorNode?: React.ReactNode;
  endDecoratorNode?: React.ReactNode;
  offset?: number;
  /**
   * If `true`, the tooltip will not be displayed.
   */
  disabled?: boolean;
  mode?: TooltipModes;
  slotProps?: BaseTooltipProps['slotProps'] & {
    title?: { className?: string; style?: React.CSSProperties; maxNumberOfLines?: number };
    rootClassName?: string;
    arrowClassName?: string;
  };
} & Omit<BaseTooltipProps, 'color' | 'component' | 'size' | 'slots' | 'sx' | 'title' | 'slotProps'>;

export type TooltipOwnerState = BaseTooltipOwnerState;
